import { put, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'

import Logger from '@Utils/Logger'

import {
  ISuccessResponse,
  IAction,
} from '@Root/types'

import {
  createWorkspaceSuccess,
  createWorkspaceFailure,
  renameWorkspaceSuccess,
  renameWorkspaceFailure,
  deleteWorkspacesSuccess,
  deleteWorkspacesFailure,
} from './actions'

import {
  ICreateWorkspacePayload,
  ICreateWorkspaceSuccessResponseBody,
  IRenameWorkspacePayload,
  IDeleteWorkspacesPayload,
  WorkspaceActionTypes,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* createWorkspaceSaga(action: IAction<ICreateWorkspacePayload>) {
  try {
    const response: ISuccessResponse<ICreateWorkspaceSuccessResponseBody> = yield call(API.createWorkspace, action.payload)
    const payloadResponse: ICreateWorkspaceSuccessResponseBody = response.data
    yield put(createWorkspaceSuccess(payloadResponse))
    toastr.success('', 'Workspace created')
  } catch (e) {
    Logger.error(e, 'Workspace cannot be created')
    yield put(createWorkspaceFailure())
  }
}

function* renameWorkspaceSaga(action: IAction<IRenameWorkspacePayload>) {
  try {
    yield call(API.renameWorkspace, action.payload)
    yield put(renameWorkspaceSuccess(action.payload))
    toastr.success('', 'Workspace renamed')
  } catch (e) {
    Logger.error(e, 'Workspace cannot be renamed')
    yield put(renameWorkspaceFailure())
  }
}

function* deleteWorkspacesSaga(action: IAction<IDeleteWorkspacesPayload>) {
  try {
    yield call(API.deleteWorkspaces, action.payload)
    yield put(deleteWorkspacesSuccess(action.payload))
    toastr.success('', 'Workspace(s) deleted')
  } catch (e) {
    Logger.error(e, 'Workspace(s) cannot be deleted')
    yield put(deleteWorkspacesFailure())
  }
}

function* workspacesSagas() {
  yield takeLatest(WorkspaceActionTypes.CREATE_WORKSPACE, createWorkspaceSaga)
  yield takeLatest(WorkspaceActionTypes.RENAME_WORKSPACE, renameWorkspaceSaga)
  yield takeLatest(WorkspaceActionTypes.DELETE_WORKSPACES, deleteWorkspacesSaga)
}

export default workspacesSagas
